export default "__VITE_ASSET__b03EEKUb__"